// extracted by mini-css-extract-plugin
module.exports = {"item":"L_db","item__image":"L_dc"};